import { generateKeys } from '../utils';
export const services = generateKeys({
    paymentsQueue: {
        id: 'payments-queue',
        name: 'Payments Queue',
    },
});
export const cellxpertCommandTypes = generateKeys({
    report: {
        value: 'report',
    },
    commissions: {
        value: 'commissions',
    },
    traders: {
        value: 'traders',
    },
    affiliatelist: {
        value: 'affiliatelist',
    },
    ftd: {
        value: 'ftd',
    },
});
